<div>
  <h1 class="other-integrations-title">{{ integrationType() }} muissa integraatioissa</h1>
  <div class="other-integrations-content">
    @if (integrationUrls().length) {
      @for (url of integrationUrls(); track url.title) {
        <a class="plain-link" [href]="url.url" target="_blank">
          {{ url.title }}
          <mat-icon inline>open_in_new</mat-icon>
        </a>
      }
    } @else {
      <span class="no-integrations">Ei näytettäviä integraatioita</span>
    }
  </div>
</div>
